import React, { useEffect, useRef, useState } from "react";
import useAIConfigs from "@/hooks/useAIConfigs";
import useApi from "@/hooks/useApi";
import { useNavigate } from "react-router-dom";
import { AIConfiguration } from "../types";

export default function AINewCreateChatbotButton() {
  const { aiConfigurations, add, update } = useAIConfigs();
  const api = useApi();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);
  const pendingConfigRef = useRef<AIConfiguration | null>(null);

  useEffect(() => {
    const saveNewChatbot = async () => {
      const pendingConfig = pendingConfigRef.current;
      if (!creating || !pendingConfig || pendingConfig.id !== 0) {
        return;
      }

      const response = await api.messaging.post("AIConfiguration", pendingConfig);
      if (response.ok) {
        const savedConfig = await response.json();
        // Find the index of the pending config by reference
        const index = aiConfigurations.indexOf(pendingConfig);
        if (index !== -1) {
          update(savedConfig, index);
        }
        navigate(`/ai-new/settings/general/${savedConfig.id}`);
      }
      pendingConfigRef.current = null;
      setCreating(false);
    };
    saveNewChatbot();
  }, [creating, aiConfigurations, api.messaging, navigate, update]);

  const handleCreate = () => {
    const newConfig = add();
    pendingConfigRef.current = newConfig;
    setCreating(true);
  };

  return (
    <button
      onClick={handleCreate}
      disabled={creating}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
    >
      <span className="text-base leading-none">+</span>
      {creating ? "Creating…" : "New Chatbot"}
    </button>
  );
}
